export default __webpack_public_path__ + "static/media/billboard.71e7f978.png";